import type { Project, ProjectTask, Service } from "../types/database";

export interface CommandItem {
  id: string;
  label: string;
  hint?: string;
  group: "Projects" | "Tasks" | "Services" | "Actions";
  onSelect: () => void;
}

interface BuildArgs {
  projects: Project[];
  tasks: ProjectTask[];
  services: Service[];
  onPickProject: (id: string) => void;
  onPickTask: (id: string) => void;
  onPickService: (id: string) => void;
  onNewTask: () => void;
  onFocusEditor: () => void;
  onShowHelp: () => void;
}

export function buildCommandItems(args: BuildArgs): CommandItem[] {
  const items: CommandItem[] = [];

  for (const p of args.projects) {
    items.push({
      id: `project:${p.id}`,
      label: p.name,
      hint: p.tagline ?? p.health_reason ?? "",
      group: "Projects",
      onSelect: () => args.onPickProject(p.id),
    });
  }

  for (const t of args.tasks) {
    items.push({
      id: `task:${t.id}`,
      label: t.title,
      hint: `${t.project} · ${t.status}`,
      group: "Tasks",
      onSelect: () => args.onPickTask(t.id),
    });
  }

  for (const s of args.services) {
    items.push({
      id: `service:${s.id}`,
      label: s.name,
      hint: `${s.category ?? ""} · ${s.status}`,
      group: "Services",
      onSelect: () => args.onPickService(s.id),
    });
  }

  items.push({
    id: "action:new-task",
    label: "New task on selected project",
    hint: "⌘N",
    group: "Actions",
    onSelect: args.onNewTask,
  });
  items.push({
    id: "action:focus-editor",
    label: "Focus note editor",
    hint: "⌘E",
    group: "Actions",
    onSelect: args.onFocusEditor,
  });
  items.push({
    id: "action:help",
    label: "Show keyboard help",
    hint: "?",
    group: "Actions",
    onSelect: args.onShowHelp,
  });

  return items;
}
